<template>
  <div class="bulk-charge-details-display">
    <div class="row">
      <div class="col-md-6">
        <h4>Bulk Charge Details</h4>
        <div class="list-group-item">
          <template v-for="charge in bulkCharge.charges">
            <div class="row">
              <div class="col-xs-3 col-sm-4 col-md-5">
                <p><strong>{{ charge.name }}</strong></p>
              </div>
              <div class="col-xs-9 col-sm-8 col-md-7">
                <p>${{ charge.cost }}</p>
              </div>
            </div>
          </template>
          <div class="row">
            <hr/>
            <div class="col-xs-3 col-sm-4 col-md-5">
              <p><strong>Total</strong></p>
            </div>
            <div class="col-xs-9 col-sm-8 col-md-7">
              <p>${{ bulkCharge.cost }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <h4>Account Note</h4>
        <div class="list-group-item">
          <account-note-display :note="note"></account-note-display>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AccountNoteDisplay from './AccountNoteDisplay.vue'
export default {
  name: 'BulkChargeDisplay',
  components: {
    AccountNoteDisplay
  },
  data () {
    return {
      bulkCharge: {
        charges: []
      },
      note: {
        AmazonImages: []
      }
    }
  },
  route: {
    data () {
      this.refreshData()
    }
  },
  methods: {
    nl2br (message) {
      return this.filter('nl2br')(message)
    },
    refreshData () {
      let params = this.$route.query
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/bulkCharge`, { params }).then(({ data }, status, request) => {
        this.bulkCharge = data.object.charge
        this.note = data.object.note
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/BulkChargeDisplay.vue